import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "lesson-unlink"
};
var _hoisted_2 = {
  class: "top-panel"
};
var _hoisted_3 = {
  class: "header-title"
};
var _hoisted_4 = {
  class: "time-tip"
};
var _hoisted_5 = {
  class: "content-box"
};
import IframeContainer from '@/components/IframeContainer/index.vue';
export default {
  __name: 'LessonUnlinkIn',
  setup: function setup(__props) {
    var yesterday = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
    var yesterdayStr = yesterday.toLocaleDateString().replace(/\//g, '-');
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[0] || (_cache[0] = _createTextVNode(" 学生课堂未连入统计 ", -1)), _createElementVNode("span", _hoisted_4, "数据更新时间:" + _toDisplayString(_unref(yesterdayStr)) + " 24:00:00", 1)])]), _createElementVNode("div", _hoisted_5, [_createVNode(IframeContainer, {
        src: "https://report.zhixuehuijiao.cn/webroot/decision/view/report?viewlet=lesson_unconn%252Flesson_unconn_report.cpt"
      })])]);
    };
  }
};